// import { scroller } from 'react-scroll';

import {
    SELECT_PRODUCT_UPDATE_REQUESTED,
    SELECT_PRODUCT_UPDATE_COMPLETED,
    SELECT_PRODUCT_UPDATE_ERROR,
} from './types';

const updateSelectProductAction = async data => async (dispatch) => {
    dispatch({
        type: SELECT_PRODUCT_UPDATE_REQUESTED,
    });
    /*
    scroller.scrollTo('ToolResult', {
        duration: 200,
        delay: 10,
        smooth: true,
        offset: -300,
    });
    */

    try {
        return dispatch({
            type: SELECT_PRODUCT_UPDATE_COMPLETED,
            payload: data,
        });
    } catch (err) {
        return dispatch({
            type: SELECT_PRODUCT_UPDATE_ERROR,
            payload: err,
        });
    }
};

export default updateSelectProductAction;
